/* rute-lite.js — 12.07.2026
   Замінює jQuery 3.7.1 + Slick + Fancybox (63 KB блокуючих з cdnjs) на ~4 KB vanilla.

   Три модулі:
     1) CAROUSEL — створює ТОЧНО ТУ САМУ DOM-структуру і класи, що й Slick
        (.slick-initialized > .slick-list > .slick-track > .slick-slide,
         кнопки .slick-arrow.left/.right). Тому весь наш CSS у main.css
         працює без жодної правки — саме тому не брали Swiper.
     2) LIGHTBOX — нативний <dialog> замість Fancybox, для [data-fancybox]
        (і картинки, і відео).
     3) MODAL — exit-intent попап, що жив на $('.modal').show(400).

   Завантажується з defer → НЕ блокує рендер.
   Відкат: python3 rollback.py theme.liquid  (поверне cdnjs-скрипти)
*/
(function () {
  'use strict';

  /* ============================ 1. CAROUSEL ============================ */
  function Carousel(root, opts) {
    var items = Array.prototype.slice.call(root.children);
    if (!items.length || root.classList.contains('slick-initialized')) return;

    var list = document.createElement('div');
    list.className = 'slick-list';
    var track = document.createElement('div');
    track.className = 'slick-track';
    list.appendChild(track);

    items.forEach(function (el) {
      el.classList.add('slick-slide');
      track.appendChild(el);
    });
    root.appendChild(list);
    root.classList.add('slick-initialized', 'slick-slider');

    list.style.overflow = 'hidden';
    track.style.display = 'flex';
    track.style.transition = 'transform .4s ease';
    track.style.willChange = 'transform';

    var index = 0;

    function perView() {
      var w = window.innerWidth;
      if (w <= 480) return opts.mobile || 1;
      if (w <= 989 && opts.tablet) return opts.tablet;
      return opts.show || 1;
    }

    function maxIndex() {
      return Math.max(0, items.length - perView());
    }

    function step() {
      // реальна ширина слайда + його зовнішні відступи (variableWidth у Slick)
      var first = items[0];
      if (!first) return 0;
      var r = first.getBoundingClientRect();
      var cs = getComputedStyle(first);
      return r.width + parseFloat(cs.marginRight || 0) + parseFloat(cs.marginLeft || 0);
    }

    function render() {
      var mi = maxIndex();
      if (index > mi) index = opts.infinite ? 0 : mi;
      if (index < 0) index = opts.infinite ? mi : 0;
      track.style.transform = 'translateX(' + (-index * step()) + 'px)';
    }

    function go(d) { index += d; render(); }

    // кнопки — ті самі класи, що робив Slick
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'slick-arrow left';
    prev.setAttribute('aria-label', 'Попередній');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'slick-arrow right';
    next.setAttribute('aria-label', 'Наступний');

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var navHost = opts.appendArrows ? document.querySelector(opts.appendArrows) : null;
    (navHost || root).appendChild(prev);
    (navHost || root).appendChild(next);

    // свайп пальцем — цього Slick теж давав
    var x0 = null;
    list.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    list.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(render, 150);
    });

    // картинки можуть доїхати пізніше і змінити ширину слайда
    window.addEventListener('load', render);
    render();
  }

  /* ============================ 2. LIGHTBOX ============================ */
  var dlg = null;

  function ensureDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'rute-lb';
    dlg.innerHTML =
      '<button type="button" class="rute-lb__close" aria-label="Закрити">&times;</button>' +
      '<div class="rute-lb__body"></div>';
    document.body.appendChild(dlg);

    dlg.querySelector('.rute-lb__close').addEventListener('click', close);
    // клік по тлу — закрити
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () {
      dlg.querySelector('.rute-lb__body').innerHTML = '';
    });
    return dlg;
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
  }

  function open(href) {
    var d = ensureDialog();
    var body = d.querySelector('.rute-lb__body');
    var isVideo = /\.(mp4|webm|mov|m4v)(\?|$)/i.test(href);

    body.innerHTML = isVideo
      ? '<video src="' + href + '" controls autoplay playsinline></video>'
      : '<img src="' + href + '" alt="">';

    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');   // дуже старі браузери
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-fancybox], a.fancybox');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    open(href);
  });

  /* ============================= 3. MODAL ============================= */
  // Був: $('.modal').show(400) / $('.modal').remove()
  window.ruteShowModal = function () {
    var m = document.querySelector('.modal');
    if (!m) return;
    m.style.display = 'block';
    m.style.opacity = 0;
    m.style.transition = 'opacity .4s ease';
    requestAnimationFrame(function () { m.style.opacity = 1; });
  };

  function initModalClose() {
    document.addEventListener('click', function (e) {
      var c = e.target.closest('.modal_close');
      if (!c) return;
      e.preventDefault();
      var m = document.querySelector('.modal');
      if (m && m.parentNode) m.parentNode.removeChild(m);
    });
  }

  /* ============================== ЗАПУСК ============================== */
  function init() {
    initModalClose();

    // Було в home_reviews.liquid: slidesToShow 2, variableWidth, infinite,
    // стрілки в .home_reviews_nav; на <481px — 1 слайд.
    var hr = document.querySelector('.home_reviews_overlay');
    if (hr) {
      Carousel(hr, { show: 2, mobile: 1, infinite: true, appendArrows: '.home_reviews_nav' });
    }

    // Було в product_video_review.liquid: slidesToShow 4, стрілки всередині.
    document.querySelectorAll('.video_review_slider').forEach(function (el) {
      Carousel(el, { show: 4, tablet: 3, mobile: 2, infinite: false });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
